export default {
  fontSize: 6,
  fontFamily: 'clear-sans-regular',
  textAnchor: 'start',
};

export const TooltipStyle = {
  fill: 'white',
  fontSize: 6,
  textAnchor: 'left',
  fontFamily: 'clear-sans-regular',
  fontFamilyBold: 'clear-sans-bold',
};
